const ProgressBar = ({ progress, duration, elapsed }) => {
  return (
    <div className="space-y-2">
      <div className="relative">
        <div className="bg-gray-100 rounded-full overflow-hidden">
          <div
            className="bg-blue-500 h-2"
            role="progressbar"
            aria-label="music progress"
            aria-valuenow={progress}
            aria-valuemin="0"
            aria-valuemax="100"
            style={{width: progress}}
          ></div>
        </div>
        
      </div>
      <div className="flex justify-between text-sm leading-6 font-medium tabular-nums">
        <div className="text-black">{elapsed}</div>
        <div className="text-black">{duration}</div>
      </div>
    </div>
  );
};

export default ProgressBar;
